import { render, staticRenderFns } from "./CheckerboardColorControl.vue?vue&type=template&id=ac5c7842"
import script from "./CheckerboardColorControl.vue?vue&type=script&lang=js"
export * from "./CheckerboardColorControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports